import { useState } from "react";
import { Share2 } from "lucide-react";
import ShareSheet from "@/components/yts/ShareSheet";
import { useLang } from "@/lib/i18n";
import { shareMessage } from "@/lib/share";

/**
 * A share action for any page or card. Pass `url` when the thing being shared
 * has its own link (a business's readable address, a story); otherwise the page
 * the visitor is on is shared.
 */
export default function ShareButton({ title, text = undefined, url, label = undefined, className = undefined }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={
          className ||
          "glass-btn rounded-[12px] px-4 py-2.5 text-[12px] font-bold inline-flex items-center gap-1.5 transition-transform active:scale-95"
        }
      >
        <Share2 className="w-4 h-4" /> {label || t("detail.share")}
      </button>
      <ShareSheet
        open={open}
        onOpenChange={setOpen}
        title={title}
        text={text || shareMessage(title)}
        url={shareUrl}
      />
    </>
  );
}